import React from 'react'
import PropTypes from 'prop-types'

const BackOutline24 = ({ color, height, strokeWidth, width }) => (
   <svg width={width} height={height} viewBox="0 0 24 24">
      <g
         fill={color}
         stroke={color}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}>
         <line fill="none" x1="22" x2="2" y1="12" y2="12" />
         <polyline fill="none" points="9,19 2,12 9,5 " />
      </g>
   </svg>
)

BackOutline24.propTypes = {
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

BackOutline24.defaultProps = {
   color: '#444',
   height: '24px',
   strokeWidth: '1px',
   width: '24px'
}

export default BackOutline24
